import TraditionalAuctionJSON from './TraditionalAuction.json';

const contract = require('@truffle/contract');

export default contract({
  abi: TraditionalAuctionJSON.abi,
});
